module.exports = __webpack_public_path__ + "img/2024-09-19b_4.7b161591.jpg";